const enum FeatureFlags {
  SHOW_CALL_PLAN_TAB = "SHOW_CALL_PLAN_TAB",
}

export default FeatureFlags;
